module.exports = __webpack_public_path__ + "static/img/process.444a40e9.png";